export const isProduction = process.env.NODE_ENV === 'production'
export const isDevelopHost = ['dev.foxgid.com', 'localhost'].includes(
  window.location.hostname,
)
